import { render, staticRenderFns } from "./webFormQuestion.vue?vue&type=template&id=549c4d16&"
import script from "./webFormQuestion.js?vue&type=script&lang=js&"
export * from "./webFormQuestion.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports